function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import shopMall from '@/pages/shopMall/routes';
import agreementModule from '@/pages/agreementModule/routes';
import commodityModule from '@/pages/commodityModule/routes';
import configureModule from '@/pages/configureModule/routes';
import contractModule from '@/pages/contractModule/routes';
import memberCenter from '@/pages/memberCenter/routes';
import operateModule from '@/pages/operateModule/routes';
import orderModule from '@/pages/orderModule/routes';
import paySettlementModule from '@/pages/paySettlementModule/routes';
import planModule from '@/pages/planModule/routes';
import supplierModule from '@/pages/supplierModule/routes';
import maxgraph from '@/pages/maxgraph/routes';
import extModule from '@/pages/extModule/routes';
import storeModule from '@/pages/storeModule/routes';
import pocOrderModule from '@/pages/pocOrderModule/routes.js';
import accountCenter from '@/pages/accountCenter/routes.js';
import marketModule from '@/pagesMarket/routes.js';
/**
 * 在主框架内显示
 */

var frameIn = [{
  path: '/index',
  name: 'index',
  redirect: {
    name: 'memberCenter'
  },
  component: function component() {
    return import('@/layouts/basic-layout');
  },
  children: [{
    path: 'log',
    name: 'log',
    meta: {
      title: '前端日志',
      auth: true
    },
    component: function component() {
      return import('@/pages/system/log');
    }
  }, {
    path: 'error402',
    name: 'error402',
    meta: {
      title: 'error402'
    },
    component: function component() {
      return import('@/pages/error/error402');
    }
  }, {
    path: 'error403',
    name: 'error403',
    meta: {
      title: 'error403'
    },
    component: function component() {
      return import('@/pages/error/error403');
    }
  }, {
    path: 'error404',
    name: 'error404',
    meta: {
      title: 'error404'
    },
    component: function component() {
      return import('@/pages/error/error404');
    }
  }, {
    path: 'error500',
    name: 'error500',
    meta: {
      title: 'error500'
    },
    component: function component() {
      return import('@/pages/error/error500');
    }
  }, {
    path: 'errorWarning',
    name: 'errorWarning',
    meta: {
      title: '警告'
    },
    component: function component() {
      return import('@/pages/error/errorWarning');
    }
  }, // 刷新页面 必须保留
  {
    path: 'refresh',
    name: 'refresh',
    hidden: true,
    component: {
      beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (instance) {
          return instance.$router.replace(from.fullPath);
        });
      },
      render: function render(h) {
        return h();
      }
    }
  }, // 页面重定向 必须保留
  {
    path: 'redirect/:route*',
    name: 'redirect',
    hidden: true,
    component: {
      beforeRouteEnter: function beforeRouteEnter(to, from, next) {
        next(function (instance) {
          return instance.$router.replace(JSON.parse(from.params.route));
        });
      },
      render: function render(h) {
        return h();
      }
    }
  }]
}, agreementModule, // 协议管理路由
commodityModule, // 商品管理路由
configureModule, // 配置中心路由
contractModule, // 合同管理路由
memberCenter, // 我的首页路由
operateModule, // 运营管理路由
orderModule, // 订单管理路由
paySettlementModule, // 支付结算管理路由
planModule, // 计划管理路由
supplierModule, // 供应商管理路由
maxgraph, // demo路由
extModule, // iframe 路由
storeModule, // 店铺管理路由
pocOrderModule, // 低代码无协议订单模块路由
accountCenter // 财务中心/账号中心部分低代码重构页面路由
];
/**
 * 在主框架之外显示
 */

var frameOut = [].concat(_toConsumableArray(shopMall), [// 商城路由
// 内部采购企业-订单管理-电商订单管理-订单评价
{
  path: '/evaluate',
  name: '/evaluate',
  meta: {
    title: '订单评价',
    menuTab: '',
    hidden: true
  },
  component: function component() {
    return import('@/pages/orderModule/evaluateMenu/evaluate.vue');
  }
}, // 运营管理-订单管理-评价管理-追评
{
  path: '/reviewOrder',
  name: '/reviewOrder',
  meta: {
    title: '追评',
    cache: true
  },
  component: function component() {
    return import('@/pages/orderModule/evaluateMenu/reviewOrder.vue');
  }
}, // 八爪鱼页面爬取数据
{
  path: '/selectModelReptile',
  name: '/selectModelReptile',
  meta: {
    title: '数据获取',
    cache: true
  },
  component: function component() {
    return import('@/pages/extReptile/bzyReptile.vue');
  }
}]);
/**
 * 电器集市路由
 */

var marketFrame = _toConsumableArray(marketModule);
/**
 * 错误页面
 */


var errorPage = [{
  path: '/403',
  name: '403',
  meta: {
    title: '403'
  },
  component: function component() {
    return import('@/pages/system/error/403');
  }
}, {
  path: '/500',
  name: '500',
  meta: {
    title: '500'
  },
  component: function component() {
    return import('@/pages/system/error/500');
  }
}, {
  path: '*',
  name: '404',
  meta: {
    title: '404'
  },
  component: function component() {
    return import('@/pages/system/error/404');
  }
}]; // 导出需要显示菜单的

export var frameInRoutes = frameIn; // 重新组织后导出

export default [].concat(frameIn, _toConsumableArray(frameOut), _toConsumableArray(marketFrame), errorPage); // 路由白名单，此名单路由不拦截

var whiteList = [/casBridge/, // 中转页面
/shopping/, // 商城首页
/list/, // 商城列表页
/shopList/, // 品牌列表
/shopIndex/, // 店铺首页
/shopGoodList/, // 店铺内商品列表
/ecDetail/, // 商城详情页-电商
/agrDetail/, // 商城详情页-协议
/unagrdetail/, // 商城详情页-无协议
/login/, // 登录
/register/, // 注册
/authentication/, // 忘记密码
/noticeList/, // 公告列表
/noticeDetail/, // 公告详情
/newsList/, // 公告列表
/newsDetail/, // 新闻详情
/helpCenter/, // 帮助中心
/merchantPlatform/, // 商家平台
/infoReg/, // 商家平台 - 信息登记
/merchantPolicy/, // 商家平台 - 政策
/onlineEnquiry/, /enquiryRecord/, /enquiryDetail/, /shopIntroduction/, //公司简介
/shopContactUs/, //联系我们
/newShopIndex/, // 新版店铺
/newShopping/, /newList/, /shopHome/, /newShopGoodList/, /brandHall/, /creditApplication/, /limitApplication/, /limitApplicationMobile/, /creditApplicationMobile/, /shopAggregation/, /largeOrder/, /largeOrderMobile/, /m_outOrderDetail/, /divideOrder/, /divideOrderMobile/, /selectModel/, /selectModelReptile/, /zhiChiCommodity/, /zhiChiOrder/, /legalExaminationAndApproval/, /legalExaminationAndApprovalMobile/, /goInquiry/ //电器集市-去询价
]; // 白名单

export var isInWhiteList = function isInWhiteList(name) {
  var res = whiteList.some(function (item) {
    return name.match(item);
  });
  return res;
}; // 电器集市路由白名单

var marketWhiteList = [/market/, /m-home/, /m-goInquiry/, //去询价
/m-orderConfirm/, //订单确认
/m-shopRegister/ // 注册
];
export var marketIsInWhiteList = function marketIsInWhiteList(name) {
  return marketWhiteList.some(function (item) {
    return name.match(item);
  });
};